import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import PreviewPdf from "./preview-pdf"
import { z } from "zod"
import { invoiceSchema } from "./invoice.schema"

interface InvoicePreviewPdfModalProps {
  invoice: z.input<typeof invoiceSchema>;
}

export default function InvoicePreviewPdfModal({
  invoice,
}: InvoicePreviewPdfModalProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button type="button" variant="outline">
          Preview
        </Button>
      </DialogTrigger>
      <DialogContent className="h-full sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Invoice Preview</DialogTitle>
          <DialogClose />
        </DialogHeader>
        <PreviewPdf invoice={invoice} />
      </DialogContent>
    </Dialog>
  )
}
